// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otherCard__Wzgmf {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: var(--tables-primary-row-surface-default);
  border: 1px solid var(--header-stroke);
}

.otherCardBody__vfXb1 {
  padding: 25px;
  display: flex;
  flex-direction: column;
  gap: 25px;
}
@media (max-width: 800px) {
  .otherCardBody__vfXb1 {
    padding: 15px;
  }
}

.otherCardIcon__jvSsa {
  display: flex;
  align-items: flex-start;
}
.otherCardIcon__jvSsa svg {
  width: 52px;
  height: 52px;
}

.otherCardTitle__wGdco {
  margin: unset;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  color: var(--tables-primary-row-text-main);
  font-style: normal;
}

.otherCardInfo__cFdfS {
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 12px;
  line-height: 18px;
  font-style: normal;
  font-weight: 400;
  overflow-y: auto;
  display: flex;
  height: 100%;
}
.otherCardInfo__cFdfS::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.otherCardInfo__cFdfS::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.otherCardInfo__cFdfS::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.otherCardInfo__cFdfS::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.otherCardDescription__wZ2kR {
  margin: unset;
  margin-top: auto;
}

.otherCardFooter__Ltw8s {
  border-top: 1px solid var(--tables-primary-row-stroke);
  padding: 15px 25px;
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 800px) {
  .otherCardFooter__Ltw8s {
    padding: 15px;
  }
}

.link__IIHyw {
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  text-transform: uppercase;
  text-align: center;
  font-style: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  color: var(--buttons-text-secondary);
  text-decoration: none;
}
.link__IIHyw:hover {
  color: var(--buttons-hover);
}
.link__IIHyw:active {
  color: var(--buttons-focused);
}
.link__IIHyw:disabled {
  color: var(--buttons-disable);
}`, "",{"version":3,"sources":["webpack://./../src/pages/HelpAndResources/components/OtherCard/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,qDAAA;EACA,sCAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAzEF;AA2EE;EANF;IAOI,aAAA;EAxEF;AACF;;AA2EA;EACE,aAAA;EACA,uBAAA;AAxEF;AAyEE;EACE,WAAA;EACA,YAAA;AAvEJ;;AA2EA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,0CAAA;EACA,kBAAA;AAxEF;;AA2EA;EACE,iDAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,aAAA;EACA,YAAA;AAzEF;AAvBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAyBJ;AAtBE;EACE,+BAAA;EACA,kBAAA;AAwBJ;AArBE;EACE,8BAAA;EACA,kBAAA;AAuBJ;AApBE;EACE,gBAAA;EACA,kBAAA;AAsBJ;;AA2DA;EACE,aAAA;EACA,gBAAA;AAxDF;;AA2DA;EACE,sDAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;AAxDF;AA0DE;EANF;IAOI,aAAA;EAvDF;AACF;;AA0DA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,oCAAA;EACA,qBAAA;AAvDF;AAyDE;EACE,2BAAA;AAvDJ;AAyDE;EACE,6BAAA;AAvDJ;AAyDE;EACE,6BAAA;AAvDJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.otherCard {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background: var(--tables-primary-row-surface-default);\n  border: 1px solid var(--header-stroke);\n}\n\n.otherCardBody {\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n\n  @media (max-width: 800px) {\n    padding: 15px;\n  }\n}\n\n.otherCardIcon {\n  display: flex;\n  align-items: flex-start;\n  svg {\n    width: 52px;\n    height: 52px;\n  }\n}\n\n.otherCardTitle {\n  margin: unset;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n  letter-spacing: 0.7px;\n  text-transform: uppercase;\n  color: var(--tables-primary-row-text-main);\n  font-style: normal;\n}\n\n.otherCardInfo {\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 12px;\n  line-height: 18px;\n  font-style: normal;\n  font-weight: 400;\n  @include scrollBar;\n  overflow-y: auto;\n  display: flex;\n  height: 100%;\n}\n\n.otherCardDescription {\n  margin: unset;\n  margin-top: auto;\n}\n\n.otherCardFooter {\n  border-top: 1px solid var(--tables-primary-row-stroke);\n  padding: 15px 25px;\n  display: flex;\n  justify-content: flex-end;\n\n  @media (max-width: 800px) {\n    padding: 15px;\n  }\n}\n\n.link {\n  font-family: 'Roboto', sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  text-transform: uppercase;\n  text-align: center;\n  font-style: normal;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  color: var(--buttons-text-secondary);\n  text-decoration: none;\n\n  &:hover {\n    color: var(--buttons-hover);\n  }\n  &:active {\n    color: var(--buttons-focused);\n  }\n  &:disabled {\n    color: var(--buttons-disable);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"otherCard": `otherCard__Wzgmf`,
	"otherCardBody": `otherCardBody__vfXb1`,
	"otherCardIcon": `otherCardIcon__jvSsa`,
	"otherCardTitle": `otherCardTitle__wGdco`,
	"otherCardInfo": `otherCardInfo__cFdfS`,
	"otherCardDescription": `otherCardDescription__wZ2kR`,
	"otherCardFooter": `otherCardFooter__Ltw8s`,
	"link": `link__IIHyw`
};
module.exports = ___CSS_LOADER_EXPORT___;
